export const ZAPIER_RENEWAL_WEBHOOK = 'https://hooks.zapier.com/hooks/catch/5187268/29yozgv/'
